import {useContext} from 'react'
import {ProductWiseReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {PRODUCT_WISE_REPORT_COLUMNS} from '../../utils'
import ProductWiseReportRow from './ProductWiseReportRow'
import {parseProductWiseReportRow} from '../../parsings'

const ProductWiseReportTable = () => {
  const {reportData, isLoading, filters, onSortingChange} = useContext(ProductWiseReportContext)

  return (
    <div className='sticky-table-wrapper'>
      <div className='table-responsive-wrapper'>
        <div className='table-responsive'>
          <DynamicTable
            data={reportData}
            sortableColumns={PRODUCT_WISE_REPORT_COLUMNS}
            loading={isLoading}
            TableRow={ProductWiseReportRow}
            filters={filters}
            noDataMessage='No product-wise reports found'
            onSortingChange={onSortingChange}
            tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
            tableHeaderClass='sticky-table-header'
            rowParsingFunction={parseProductWiseReportRow}
          />
        </div>
      </div>
    </div>
  )
}

export default ProductWiseReportTable
